import { beforeLoadCheckAuth } from '@/common/auth';
import { SelectContextPage } from '@/pages/select-context';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/select-context')({
	beforeLoad: beforeLoadCheckAuth,
	component: SelectContextPage,
});
